<template>
  <router-link class="btn btn-danger btn-lg" :to="to">
    <i class="fas fa-arrow-alt-circle-left"></i> {{ 'common.btn.back' | i18n }}
  </router-link>
</template>


<script>
  export default {
    props: {
      to: {
        required: true
      }
    }
  }
</script>


<style scoped>
  .btn-danger {
    background-color: #c31a2f;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/BackButton.vue